import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ir_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ir_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size, color, quantity = 1, meta = {}) => {
    setItems((prev) => {
      const key = `${product.id}-${size}-${color}-${meta.is_gift ? "gift" : "std"}`;
      const existing = prev.find(i => `${i.product.id}-${i.size}-${i.color}-${i.is_gift ? "gift" : "std"}` === key);
      if (existing) {
        return prev.map(i => i === existing ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, { product, size, color, quantity, is_gift: !!meta.is_gift, gift_note: meta.gift_note || "", gift_parent: meta.gift_parent || null, gift_recipient_name: meta.gift_recipient_name || "", gift_recipient_email: meta.gift_recipient_email || "" }];
    });
    setOpen(true);
  };

  const removeItem = (idx) => setItems(prev => prev.filter((_, i) => i !== idx));
  const updateQty = (idx, qty) => setItems(prev => prev.map((it, i) => i === idx ? { ...it, quantity: Math.max(1, qty) } : it));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.product.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return <CartCtx.Provider value={{ items, open, setOpen, addItem, removeItem, updateQty, clear, subtotal, count }}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
